import { FC } from 'react';
import { GroupField, Content } from '@prismicio/client';
import { Simplify } from '../../../../../prismicio-types';

import styles from './styles.module.scss';
import { Answer } from './Answer';

type Props = {
  questions: GroupField<
    Simplify<Content.QuestionsAnswersSliceDefaultPrimaryQuestionsItem>
  >;
};

export const Questions: FC<Props> = ({ questions }) => {
  return (
    <ul className={styles.container}>
      {questions.map((item, index) => (
        <Answer key={item.question} item={item} index={index} />
      ))}
    </ul>
  );
};
